import { render, staticRenderFns } from "./WReportDocumentSpentList.vue?vue&type=template&id=5da06443&scoped=true&"
import script from "./WReportDocumentSpentList.vue?vue&type=script&lang=js&"
export * from "./WReportDocumentSpentList.vue?vue&type=script&lang=js&"
import style0 from "./WReportDocumentSpentList.vue?vue&type=style&index=0&id=5da06443&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da06443",
  null
  
)

export default component.exports